module.exports = __webpack_public_path__ + "static/media/downarrow.3fc89807.svg";